// extracted by mini-css-extract-plugin
export default {"cta":"TH-z","disabled":"UH-z"};